import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { checkValidityOfMachine } from "../utils/checkIsMachineValid";
import { ca } from "date-fns/locale";
import ValidatingLayout from "./ValidatingLayout";


const getCookie = (n) => {
  let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
  return a ? a[1] : "";
};



function ProtectedRoute({ children }) {

  const [currentMachine, setCurrentMachine] = useState(undefined);


  useEffect(() => {

      console.log("inside time out")

      checkValidityOfMachine().then((res) => {

        console.log("res <<++++>> protected route", res)

        if (res) {

          if (document.cookie.length != 0) {

            let previousStateOfLogin = JSON.parse(getCookie("currentSatusLog"));

            if (previousStateOfLogin.isAdminLoggedIn) {
              console.log("inside isAdminLoggedIn true ././././.");


              setCurrentMachine(true)

            } else {
              console.log("inside isAdminLoggedIn false");
              setCurrentMachine(false)
            }

          } else {
            console.log("Cookie not available");

            setCurrentMachine(false)
          }

        } else {
          setCurrentMachine(false)
        }

      }).catch((err) => {
        setCurrentMachine(null)
      })

   

  }, []);


  if (currentMachine === undefined) {
    return <ValidatingLayout />;
  }

  if (!currentMachine) {
    return <Navigate to="/" />;
  }

  if (currentMachine) {

    console.log("reached children")
    return children;
  }

  


}

export default ProtectedRoute;
